export const SAVE_ALL_TEXTS = 'SAVE_ALL_TEXTS'
export const SAVE_CHAPTER_TEXT = 'SAVE_CHAPTER_TEXT'